import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { AppService } from './app.service';

@Component({
  selector: 'app-dialog-opret-udstyr',
  templateUrl: './dialog-opret-udstyr.component.html',
  styleUrls: ['./dialog-opret-udstyr.component.css']
})
export class DialogOpretUdstyrComponent implements OnInit {

  wrongInput = false
  wrongInputReason = ""

  uploading = false

  fileToUpload: File = null

  categories = []

  guideText = ""

  fg: FormGroup = new FormGroup({
    category_id: new FormControl(''),
    betegnelse: new FormControl(''),
    placering: new FormControl(''),
    postnr: new FormControl(''),
    minimumsFrist: new FormControl(''),
    saerligt: new FormControl(''),
    ejernavn: new FormControl(''),
    kpNavn: new FormControl(''),
    kpEmail: new FormControl(''),
    kpTlf: new FormControl('')
  })

  //@Inject(MAT_DIALOG_DATA) public data
  constructor(private serv: AppService, public dialogRef: MatDialogRef<DialogOpretUdstyrComponent>
    ) { }

  ngOnInit(): void {
    this.serv.getCategories().subscribe(ret => {
      this.categories = ret['categories']
    })
    this.serv.getConf().subscribe(ret => {
      this.guideText = ret['gear_edit_guide']
    })

    this.fg.get('minimumsFrist').setValue('1')
  }

  handleFileInput(files: FileList) {
    this.fileToUpload = files.item(0);
}

  doSubmit() {
    this.uploading = true

    this.serv.addGear(this.fileToUpload,
      this.fg.get('category_id').value,
      this.fg.get('betegnelse').value,
      this.fg.get('placering').value,
      this.fg.get('postnr').value,
      this.fg.get('minimumsFrist').value,
      this.fg.get('saerligt').value,
      this.fg.get('ejernavn').value,
      this.fg.get('kpNavn').value,
      this.fg.get('kpEmail').value,
      this.fg.get('kpTlf').value).subscribe(ret => {
        if (ret['result']) {
          this.dialogRef.close(true)
        } else {
          this.uploading = false
          this.wrongInput = true
          this.wrongInputReason = ret['reason']
        }
      })
  }
}
